import { Mui } from '@osu/react-ui';
import Chip from './scoresChip';
import styles from '../../dd-styles';

const ACTScores = (props) => {
  const { studentData } = props;

  if (!(studentData?.data?.scores?.act?.length > 0)) {
      return (
        <>
          <Mui.Typography tabIndex="0" aria-label='A C T' component="h3" variant="h6" key={1}>
            ACT
          </Mui.Typography>
          <Mui.Typography style={{marginLeft: '.5rem'}}>No test information available</Mui.Typography>
        </>
      )   
    }
  
  return (
    <>
      <Mui.Typography aria-label='A C T' tabIndex="0" component="h3" variant="h6">
        ACT
      </Mui.Typography>
      {studentData?.data?.scores?.act?.length > 0 ? (
        <>
          <Mui.Box style={{ display: 'flex', flexWrap: 'wrap' }}>
            {studentData?.data?.scores?.act?.map?.((item, index) => (
              <dl title="A C T" key={index} style={styles.dl}>
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'Date'}
                    childLabel={item.map((item) => item.date ?? "N/A")}
                  />
                </dd>
                {<Mui.Box component="dd" tabIndex="0" sx={{ ...styles.dd, ...styles.ddtestid }}><Chip childLabel={item.map(item => item?.testId)} /></Mui.Box> }
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'Composite'}
                    childLabel={item.map((item) => item.composite ?? "N/A")}
                  />
                </dd>
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'Math'}
                    childLabel={item.map((item) => item.math ?? "N/A")}
                  />
                </dd>
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'Reading'}
                    childLabel={item.map((item) => item.reading ?? "N/A")}
                  />
                </dd>
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'English'}
                    childLabel={item.map((item) => item.english ?? "N/A")}
                  />
                </dd>
                <dd tabIndex="0" style={styles.dd}>
                  <Chip
                    label={'Science'}
                    childLabel={item.map((item) => item.science ?? "N/A")}
                  />
                </dd>
                <Mui.Divider />
              </dl>
            ))}
          </Mui.Box>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default ACTScores;
